// extracted by mini-css-extract-plugin
module.exports = {"icon":"loading-block_icon__2sgVX"};